/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import {
  Container,
  List,
  Segment,
  Grid,
  //GridRow,
  GridColumn,
  //Icon,
  //Button,
  //ButtonContent,
} from 'semantic-ui-react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';

import { useGoogleAnalytics } from 'volto-google-analytics';
const messages = defineMessages({
  copyright: {
    id: 'Copyright',
    defaultMessage: 'Copyright',
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  useGoogleAnalytics();
  return (
    <div class="footer-container print_hide">
      <Segment
        role="contentinfo"
        vertical
        padded
        inverted
        id="footer"
        aria-label="Footer"
      >
        <div>
          <div id="footer-main">
            <Grid padded stackable>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>About</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/about/history">History</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/governance">Governance</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="https://drugfreesport.org.za/" target="_blank">Anti-Doping</UniversalLink>
                    </List.Item>
                  </List.Content>
                  <List.Header>
                    <h4>Media</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/news">News</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="https://www.youtube.com/channel/UCxUg5eqtMDw2mRtOmv22B1w?themeRefresh=1" target="_blank">SwimSA TV</UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>Events & Results</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/events-results/upcoming-events">Upcoming Events</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/events-results/all-events">All Events</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/events-results/results">Results</UniversalLink>
                    </List.Item>
                  </List.Content>
                  <List.Header>
                    <h4>Disciplines</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/disciplines/swimming">Swimming</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/disciplines/open-water">Open Water</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/disciplines/waterpolo">Waterpolo</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/disciplines/diving">Diving</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/disciplines/artistic-swimming">Artistic Swimming</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/disciplines/para-swimming">Para Swimming</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/disciplines/masters-swimming">Masters Swimming</UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>Education</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/education/about">About</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/education/learn-to-swim">Learn To Swim</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/education/swim-schools">Swim Schools</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/education/downloads">Downloads</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/education/calendar">Calendar</UniversalLink>
                    </List.Item>
                  </List.Content>
                  <List.Header>
                    <h4>Contact us</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/about/contact/contact-swimsa">Contact SwimSA</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/contact/affiliates">Affiliates</UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={6} textAlign="right" verticalAlign="bottom">
                <List>
                  <List.Content>
                    <List.Item className="footer-sitesocial">
                      <List horizontal>
                        <List.Item>
                          <UniversalLink
                            href="https://x.com/SwimSouthAfrica"
                            target="_blank"
                            title="X"
                          >
                            <i class="bi bi-twitter-x"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.youtube.com/user/SwimSouthAfrica/"
                            target="_blank"
                            title="YouTube"
                          >
                            <i class="bi bi-youtube"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.facebook.com/pages/Swimming-South-Africa/239444916077713"
                            target="_blank"
                            title="Facebook"
                          >
                            <i class="bi bi-facebook"></i>
                          </UniversalLink>
                        </List.Item>
                      </List>
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      <FormattedMessage
                        id="{copyright} Swimming South Africa {current_year}"
                        defaultMessage="{copyright} Swimming South Africa {current_year}"
                        values={{
                          copyright: (
                            <abbr
                              title={intl.formatMessage(messages.copyright)}
                            >
                              ©
                            </abbr>
                          ),
                          current_year: new Date().getFullYear(),
                        }}
                      />
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      Stock images/videos courtesy of <a href="https://www.pexels.com" target="_blank">Pexels</a> & <a href="https://unsplash.com" target="_blank">Unsplash</a>
                    </List.Item>
                    <List.Item>
                      <UniversalLink
                        href="#top"
                        class="header-link"
                        title="Back to top"
                      >
                        <i class="bi bi-arrow-up-circle-fill"></i>
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
            </Grid>
          </div>
        </div>
      </Segment>
      <div class="belowFooter">
        <a href="https://juizi.com" target="_blank">
          <img src="https://juizi.com/juizi.png" />
        </a>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
